import { render, staticRenderFns } from "./RestBreakCancelButton.vue?vue&type=template&id=2c8f436b&"
import script from "./RestBreakCancelButton.vue?vue&type=script&lang=js&"
export * from "./RestBreakCancelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports